import "./Contact.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Contact = () => {
  return (
    <div id="contact">
      <h1 className="pt-4 text-center font-details-b pb-3">Get in Touch</h1>
      <Container>
        <Col xs={12} md={12}>
          <Row className="pt-12 pb-12 align-items-center">
            <div style={{ margin: "auto", textAlign: "center" }}>
              <p className="lead font-weight-bold"> Liked my work? Want to get in touch?<br />
                You can reach out to me at-</p>
              <p className="lead font-weight-bold">
                <a
                  href="mailto:vaibhavraj524@gmail.com?body=Your message within Main Body"
                  className="text-dark"
                >
                  <i className="far fa-envelope"></i> vaibhavraj524@gmail.com
                </a>
              </p>
              <p className="lead font-weight-bold">
                <a href="tel:+919412350237" className="text-dark">
                  <i className="fas fa-phone"></i> +91 9412350237
                </a>
              </p>
            </div>
          </Row>
        </Col>
      </Container>
    </div>
  );
};

export default Contact;
